import React from 'react';
import { connect } from 'react-redux'
import * as buildfiosaction from './../../action/buildProduct'
import ModalOverlay from './../../components/modalOverlay';
import * as modalAction from './../../action/modalWindow';
import FbeContent from './fbeContent';
import { ModalWindow } from './../../constants/actionType';
import { updateSCTags} from './../../service/dtmTag';
import { tempVzdlSCData, updateVzdlSCCustomEvent } from '../../service/vzdl';
import { TextLink } from '@vds/buttons';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Title, Body, Micro } from '@vds/typography';
import { InHomeUtils } from '../../util/inhomeUtils';


class firstBill extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    handleKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onOpenModal("SOC");
        }
      }

      onOpenModal = (e) => {
        // On iOS devcies, disable momentum scrolling - FBE rendering inside cart
        const bodyClassList = window.document.body.classList;
        if (this.props.FBESection === "cart" && bodyClassList.contains('device-ios') && !bodyClassList.contains('disable-momentum-scrolling')) {
            bodyClassList.add('disable-momentum-scrolling');
        }

        tempVzdlSCData.detail = "Estimated monthly charges";
        tempVzdlSCData.events = "prodView";
        const pathname = window.location.pathname;
        if(InHomeUtils.isNotNull(pathname) && pathname.includes('checkout')){
          updateSCTags("cart| view soc");
          tempVzdlSCData.name =  "checkout";
          updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events,name");
        }
        else if(InHomeUtils.isNotNull(pathname) && pathname.includes('ordersummary')){
            updateSCTags("monthly bill estimate+taxes");
            tempVzdlSCData.detail="monthly bill estimate + taxes";
            updateVzdlSCCustomEvent(this.props?.appState?.flowType ==='MV' ? "movesInterOrderSum" :"interOrderSum", "pageViewOmni","detail,events");
        }
        else{
          updateSCTags("cart| view soc");
          updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
        }
        buildfiosaction.fetchPostSoc(this.props.dispatch, this.props.appState.visitId, true, false, 'postSoc');
        //if (this.props.soc !== undefined && this.props.soc.postsoc !== undefined && tnull.soc.postsoc.postsocmsg === "Soc submission successful") {
        //    buildfiosaction.fetchGetSoc(this.props.dispatch, this.props.appState.visitId);
        //    modalAction.openModalWindow(e, this.props.dispatch);
        //}

    };
    closeModel =()=>{
        modalAction.closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch);
    }
    render() {
        let SocContent = "";
        if ((this.props.modalWindow.modalId === ModalWindow.ids.firstBill) && (!this.props.isCartOpen || (this.props.isCartOpen && this.props.FBESection === 'cart'))) {
            if(this.props.soc.getsoc.socResponse !==null){
               SocContent = <FbeContent data={this.props.soc.getsoc.socResponse} isFCPflow={this.props.isFCPflow} lqState={this.props.lqState} closeModel={this.closeModel} isTargetOrdering={this.props.appState.isTargetOrdering}  visitId={this.props.appState.visitId } flowType={this.props.appState.flowType} runtimeKey={this.props.runtimeKey} buildProductState={this.props.buildProductState} pfbautopay={this.props.pfbautopay}/> 
            }
            else{
                SocContent = <React.Fragment><div>
                    {/* <div className="modal_header"></div>
                    <div className="modal_content fixModalHeight">We're Sorry, We're unable to get the first month bill estimation at this time.<br/>
                Please try again</div> */}
                <ModalTitle></ModalTitle>
                <ModalBody>We're Sorry, We're unable to get the first month bill estimation at this time.<br/>
                Please try again</ModalBody>
                </div></React.Fragment>
            }
        }

        let socSection = "";
        let socSectionclassName = "";        
        let socLinkText = `Monthly bill estimate + taxes ${!this.props.isFCPflow ? " and fees" : ""}`
             
            // (<span id="fbeLinkTextId" className={this.isReskin ? 'fbeLinkTextId' : ''}><span className="screen-reader-only">Open modal showing &nbsp;</span></span>);
        

        if(this.props.FBESection === "cart"){
            // socSection =  <TextLink type="standAlone" size="small" onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal("SOC")} className="bold">{socLinkText}</TextLink> 
            socSection = <Body size="small" className="bold text-black" ><TextLink role="link" tabIndex="0" ariaLabel={`Open modal showing ${socLinkText} details`} onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal("SOC")} id="setFocusToCartElement">{socLinkText}</TextLink></Body>
        }
        else{
            // socSection =  <TextLink type="standAlone" size="small" onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal("SOC")} className="bold">{socLinkText}<span className="accordion_icon-chevron-right" aria-hidden="true"></span></TextLink>
            socSection = <Body size="small" className="text-black voiceDesc" ><TextLink role="link" tabIndex="0" ariaLabel={`Open modal showing ${socLinkText} details`} onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal("SOC")}>{socLinkText}</TextLink></Body>
            {/* <span className={!this.isReskin ? "accordion_icon-chevron-right" : ""} aria-hidden="true"></span> */}
            socSectionclassName = !this.isReskin ? "soclinkcheckout padding-right-micro" : "soclinkcheckout padding-right-micro"
        }

        return (            
                <div id='soc' className={socSectionclassName}>
                    {socSection}
                    <ModalOverlay className="vzicon small text-black middle" template={SocContent} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>                    
                </div>            
        );
    }
};


const mapStateToProps = (state) => {
    return {
        appState: state.app,
        modalWindow: state.modalWindow,
        soc: state.firstbill,
        runtimeKey:state.loopQual.runtimeKey,
        buildProductState:state.buildProduct,
        pfbautopay:state.pfbautopay,
        lqState:state.loopQual
    }
}

export default connect(mapStateToProps)(firstBill);